import React from 'react';
import { Link } from 'react-router-dom';

const HouseIcon = () => (
  <svg width="30" height="30" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="34" height="34" rx="8" fill="rgba(255,255,255,.15)" />
    <path
      d="M17 7L6 16.5h3.5V27h5v-5.5h5V27h5V16.5H28L17 7z"
      stroke="white" strokeWidth="1.8"
      strokeLinejoin="round" strokeLinecap="round" fill="none"
    />
  </svg>
);

const navLinks = [
  { label: 'Leistungen',          id: 'leistungen' },
  { label: 'Kooperationspartner', id: 'kooperationspartner' },
  { label: 'Mietinteresse',       id: 'mietinteresse' },
  { label: 'Kontakt',             id: 'kontakt' },
];

export default function Footer() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  const year = new Date().getFullYear();

  return (
    <footer className="footer2">
      <div className="footer2__accent-bar" />
      <div className="container">
        <div className="footer2__inner">

          {/* Spalte 1: Marke */}
          <div>
            <div className="footer2__logo">
              <HouseIcon />
              <span className="footer2__brand">Huusmacher</span>
            </div>
            <p className="footer2__tagline">
              Energetische Sanierung & Haussanierung in Hamburg und Bremen –
              powered by Holthey Immobilien GmbH.
            </p>
          </div>

          {/* Spalte 2: Navigation */}
          <div>
            <div className="footer2__col-title">Navigation</div>
            <div className="footer2__links">
              {navLinks.map(l => (
                <button key={l.id} className="footer2__link" onClick={() => scrollTo(l.id)}>
                  {l.label}
                </button>
              ))}
              <Link to="/impressum" className="footer2__link">Impressum & Datenschutz</Link>
            </div>
          </div>

          {/* Spalte 3: Kontakt */}
          <div>
            <div className="footer2__col-title">Standorte</div>
            <div className="footer2__contact-item">
              <svg className="footer2__contact-icon" width="15" height="15" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
                <circle cx="12" cy="9" r="2.5"/>
              </svg>
              <div className="footer2__contact-text">
                Hinter der Schule 2<br />22145 Stapelfeld<br />
                <a href="tel:04018230400">040 18230400</a>
              </div>
            </div>
            <div className="footer2__contact-item">
              <svg className="footer2__contact-icon" width="15" height="15" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
                <circle cx="12" cy="9" r="2.5"/>
              </svg>
              <div className="footer2__contact-text">
                Achterdiek 160<br />28325 Bremen<br />
                <a href="tel:01604108080">0160 4108080</a>
              </div>
            </div>
            <div className="footer2__contact-item">
              <svg className="footer2__contact-icon" width="15" height="15" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                <polyline points="22,6 12,13 2,6"/>
              </svg>
              <div className="footer2__contact-text">
                <a href="mailto:info@huusmacher.de">info@huusmacher.de</a>
              </div>
            </div>
          </div>

        </div>

        <div className="footer2__bottom">
          <span>© {year} Huusmacher · powered by Holthey Immobilien GmbH</span>
          <Link to="/impressum" className="footer2__link">Impressum</Link>
        </div>
      </div>
    </footer>
  );
}
